import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/employee_onboarding/lib/CollectionsBootstrap'

const Container = () => {
  return (
    <Outlet
      context={{
        loading: false,
      }}
    />
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
